var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};



















pug_mixins["section"] = pug_interp = function(title, cls){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(attributes, true)) + "\u003E";
if (title) {
pug_html = pug_html + "\u003Cdiv class=\"section-title\" layout-padding\u003E\u003Cdiv" + (pug.attr("class", pug.classes([cls], [true]), false, true)) + "\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"content\" layout-padding\u003E\u003Cdiv\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cmd-progress-linear ng-if=\"!vm.formTracker\" md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003Cform layout=\"column\" flex name=\"vm.consentForm\" patch-form=\"vm.formTracker\" validation-property=\"vm.validationProperty\"\u003E\u003Cfieldset ng-disabled=\"!vm.formTracker\"\u003E";
pug_mixins["section"].call({
block: function(){
pug_html = pug_html + "\u003Chelp-box\u003E\u003Ccontent-item content-item-name=\"consent-info-howHeard\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fhelp-box\u003E\u003Cmd-input-container class=\"md-block how-heard\"\u003E";
pug_mixins["required-select"].call({
block: function(){
pug_html = pug_html + "\u003Cmd-option ng-repeat=\"option in vm.howHeardOptions\" value=\"{{option.key}}\"\u003E{{option.label}}\u003C\u002Fmd-option\u003E";
}
}, 'howHeard', 'vm.consent.howHeard', 'How did you hear about us?');
pug_html = pug_html + "\u003C\u002Fmd-input-container\u003E\u003Cbr\u003E\u003Cmd-input-container class=\"md-block how-heard-other\" ng-if=\"vm.consent.howHeard === 'other'\"\u003E\u003Clabel\u003EPlease specify\u003C\u002Flabel\u003E\u003Ctextarea required name=\"howHeardOther\" ng-model=\"vm.consent.howHeardOther\"\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fmd-input-container\u003E\u003Cmd-input-container class=\"md-block how-heard-referrer\" ng-if=\"vm.consent.howHeard === 'referral'\"\u003E\u003Clabel\u003EFull name of referrer\u003C\u002Flabel\u003E\u003Ctextarea required name=\"howHeardOther\" ng-model=\"vm.consent.howHeardReferral\"\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fmd-input-container\u003E";
}
}, 'Further Information');
pug_mixins["section"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel panel=\"vm.getPanel('consent-form-preamble')\"\u003E\u003C\u002Ficon-panel\u003E\u003Cmd-checkbox class=\"agree\" name=\"agreeCheckbox\" required ng-model=\"vm.consent.iAgree\" aria-label=\"Agree to terms and conditions\"\u003E\u003Ccontent-item content-item-name=\"consent-form-iAgree\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fmd-checkbox\u003E\u003Cicon-panel panel=\"vm.getPanel('consent-form-agreement')\"\u003E\u003C\u002Ficon-panel\u003E";
}
}, "Consent");
pug_html = pug_html + "\u003C\u002Ffieldset\u003E\u003C\u002Fform\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;